<template>
  <div class="pr-5 mr-2">
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      max-height="80"
      type="image"
    ></v-skeleton-loader>
    <v-skeleton-loader
      class="mx-auto mb-2"
      min-width="300"
      type="text"
    ></v-skeleton-loader>
  </div>
</template>

<script>
export default {
  name: 'StatsSkeleton'
}
</script>
